<template>
  <div class="container">
    <div class="wrap z-flex z-flex-between">
      <div class="box-con box-con-main">
        <div class="top">
          <div class="title">{{title}}</div>
          <div class="info z-flex z-flex-center">
            <div class="info-item z-flex">
              <i class="el-icon-view"></i>
              <span>{{viewNum}}</span>
            </div>
            <div class="info-item z-flex">
              <i class="el-icon-star-off"></i>
              <span>{{collectNum}}</span>
            </div>
            <div class="info-item z-flex">
              <i class="el-icon-time"></i>
              <span>{{creatTime}}</span>
            </div>
          </div>
        </div>
        <div class="detail" v-html="detail"></div>
        <div class="detail-bottom z-flex z-flex-center">
          <el-button class="btn-collect btn-iscollect" type="primary" v-if="isCollect" @click="collect">
            <i class="iconfont icon-yishoucang"></i>
            <span>已收藏</span>
          </el-button>
          <el-button class="btn-collect" type="primary" v-else @click="collect">
            <i class="iconfont icon-shoucang"></i>
            <span>收藏</span>
          </el-button>
          <el-button class="btn-share" type="primary" @click="share">
            <i class="iconfont icon-zhuanfa"></i>
            <span>分享</span>
          </el-button>
        </div>
      </div>
      <!-- 赛事推荐 -->
      <recoMatch></recoMatch>
    </div>
  </div>
</template>

<script>
import recoMatch from "@/components/recoCom/recoMatch"
export default {
  components: {
    recoMatch,
  },
  data() {
    return {
      isCollect:false,
      title:'第一届“绿水青山·美丽中华”全国生态摄影大赛秋季获奖公布',
      creatTime:'2023-04-11 12:00:00',
      viewNum:888,
      collectNum:999,
      detail:`<p>中华民族向来尊重自然、热爱自然，绵延5000多年的中华文明孕育着丰富的生态文化</p>
              <p><img src="https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/136/1ee/1361ee6a77338e48f6280d6710fc5d07.jpg"/></p>
             `
    };
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    collect(){
      this.isCollect = !this.isCollect;
    },
    share(){

    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.box-con-main{
  width:1050px;
  .top{
    padding:20px 60px;
    border-bottom:$border;
    .title{
      text-align:center;
      font-size:20px;
      margin-bottom:15px;
    }
    .info-item{
      margin:0 15px;
      font-size:14px;
      color:#999;
      i{
        margin-right:5px;
      }
    }
  }
  .detail{
    padding:20px 40px;
    ::v-deep p{
      margin:10px 0;
    }
    ::v-deep img{
      max-width:100%;
    }
  }
  .detail-bottom{
    padding:30px 0;
    margin:0 40px;
    border-top:$borderDashed;
    .el-button{
      padding:0 20px;
      height:40px;
      .iconfont{
        margin-right: 6px;
      }
    }
    .btn-iscollect{
      background:#a2a2a2;
      border-color: #a2a2a2;
    }
  }
}
</style>
